import { projects } from "../data/projectsData";
import "../styles/projectsSection.css";

// Icon for the "Code" link, based on where the repo is hosted.
const repoIcon = (url) =>
  url.includes("gitlab.com") ? "fab fa-gitlab" : "fab fa-github";

const ProjectsSection = () => {
  return (
    <section id="projects" className="projects-section">
      <h2 className="reveal">Projects</h2>

      <div className="projects-grid">
        {projects.map((project) => {
          // The whole card opens the live app when there is one, otherwise the repo.
          const primaryLink = project.liveLink || project.repoLink;

          return (
            <article key={project.id} className="project-card reveal">
              <div className="project-thumbnail-wrapper">
                <img
                  src={project.thumbnail}
                  alt=""
                  className="project-thumbnail"
                  loading="lazy"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://placehold.co/400x250/cccccc/ffffff?text=Image+Error";
                  }}
                />
                {/* Hover reveal on devices that can hover. Hidden from screen
                    readers, which get the tagline below instead. */}
                <div className="project-overlay" aria-hidden="true">
                  <p>{project.tagline}</p>
                </div>
              </div>

              <div className="project-body">
                <h3 className="project-title">
                  {/* Stretched link: its ::after covers the card, making the
                      whole card clickable without nesting links. */}
                  <a
                    href={primaryLink}
                    className="project-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {project.title}
                  </a>
                </h3>

                {/* Shown on touch devices (no hover); visually hidden but
                    still read aloud where the overlay is used. */}
                <p className="project-tagline">{project.tagline}</p>

                <ul className="project-tech" aria-label="Technologies">
                  {project.technologies.map((tech) => (
                    <li key={tech.name}>{tech.name}</li>
                  ))}
                </ul>

                <div className="project-actions">
                  {project.liveLink && (
                    <a
                      href={project.liveLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`${project.title} live demo`}
                    >
                      <i className="fas fa-arrow-up-right-from-square"></i>
                      Live
                    </a>
                  )}
                  {project.repoLink && (
                    <a
                      href={project.repoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`${project.title} source code`}
                    >
                      <i className={repoIcon(project.repoLink)}></i>
                      Code
                    </a>
                  )}
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default ProjectsSection;
